import { backendServices } from 'common';
import {
    BuildSimDocumentArgs,
    SIM_DOCUMENT_CLASS,
    SimSubmissionContext,
    buildSimDocumentViewModel,
} from '../../_shared/simDocumentVM';
import { CertificateOfInsuranceFormViewModel } from './CertificateOfInsuranceFormViewModel';

/**
 * HeaderInfo payload for the Certificate of Insurance SIM document.
 *
 * Paths under BusinessDocument.SIMDocument.HeaderInfo:
 *   - Carrier       -> HeaderInfo.Carrier
 *   - PolicyNumber  -> HeaderInfo.PolicyNumber
 *
 * Neither field is in the current COI skeleton capture. We write them
 * anyway under HeaderInfo; the backend's Field Dictionary likely needs
 * to add these two leaves.
 *
 * TODO(SIM): confirm Carrier / PolicyNumber XPaths with backend.
 */
function coiFormToHeaderInfo(form: CertificateOfInsuranceFormViewModel): Record<string, string> {
    return {
        Carrier: form.Carrier,
        PolicyNumber: form.PolicyNumber,
    };
}

export function convertCertificateOfInsuranceFormToVM(
    form: CertificateOfInsuranceFormViewModel,
    skeleton: BuildSimDocumentArgs['skeleton'],
    context: SimSubmissionContext,
    simDocumentTypeId: number | null,
    scheduleDescription?: string | null,
    simRequestId?: number
): backendServices.ViewModels.DocumentViewModel {
    return buildSimDocumentViewModel({
        skeleton,
        context,
        documentClass: SIM_DOCUMENT_CLASS.InsuranceCertificate,
        description: scheduleDescription || 'Certificate of Insurance',
        documentType: 'COI',
        headerInfo: coiFormToHeaderInfo(form),
        simDocumentTypeId,
        simRequestId,
    });
}
